import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// shadcn/ui convention — `cn()` merges Tailwind class strings, conditionally
// applies them via `clsx`, and resolves utility conflicts (e.g. when a
// variant adds `p-4` and a caller passes `p-6` to override). Without
// `twMerge` the two pile up; with it the later one wins.
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
